import { PRIVATE_HTTP_BFF as http } from '../http-common';

const postTipification = async (tipificationKey: string, comment?: string) => {
  return http().post(`/tipification`, { tipificationKey, comment });
};

export { postTipification };
